import { Component, EventEmitter, Input, Output } from '@angular/core';

export class ButtonStyle {
  colorScheme: 'primary' | 'secondary' | 'outlined' = 'primary';
  class? = '';
}

@Component({
  selector: 'markant-platform-approve-dialog',
  templateUrl: './approve.component.html',
  styleUrls: ['./approve.component.scss'],
})
export class ApproveComponent {
  @Input() open = false;
  @Input() customClassName = '';
  @Input() text = '';
  @Input() headline = '';
  @Input() cancelButtonText = '';
  @Input() approveButtonText = '';
  @Input() buttonAlign: 'center' | 'right' = 'center';
  @Input() headlineStyle = {};
  @Input() cancelButtonStyles: ButtonStyle = {
    colorScheme: 'primary',
  };
  @Input() approveButtonStyles: ButtonStyle = {
    colorScheme: 'primary',
  };
  @Input() isButtonDisabled = false;
  @Input() isButtonLoading = false;
  @Input() approveCallback: (() => void) | undefined = undefined;
  @Input() closeCallback: (() => void) | undefined = undefined;
  @Input() closeOnApprove = false;

  @Output() isApproved = new EventEmitter<boolean>();
  @Output() calledCloseCallback = new EventEmitter<void>();
  @Output() openChange = new EventEmitter<boolean>();

  closeDialog(): void {
    this.open = false;
    this.openChange.emit(false);
    this.calledCloseCallback.emit();
  }

  approve(): void {
    this.isApproved.emit(true);
    if (this.approveCallback) {
      this.approveCallback();
    }
    if (this.closeOnApprove) {
      this.openChange.emit(false);
    }
  }
}
